import { render, staticRenderFns } from "./CatalogLayoutsListsModal.vue?vue&type=template&id=4fc13b1e&scoped=true"
import script from "./CatalogLayoutsListsModal.vue?vue&type=script&lang=js"
export * from "./CatalogLayoutsListsModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogLayoutsListsModal.vue?vue&type=style&index=0&id=4fc13b1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc13b1e",
  null
  
)

export default component.exports